import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import "../../performance/custom.css";
import useApi from "../../../core/customhook/useApi";
import {
  getFinancialYearList,
  getFinancialYearListNew,
} from "../../../core/common/financialYear";

const PerformanceReview = () => {
  const [finance_year, setFinance_year] = useState("");

  const {
    data: finYearData,
    loading: finYearLoading,
    error: finYearError,
  } = useApi("/api/get-apprisal-fin-year", {
    method: "GET",
    autoCall: true,
  });

   useEffect(() => {
      if (finYearData?.data?.fin_year) {
        setFinance_year(finYearData.data.fin_year);
      }
    }, [finYearData]);
  

  const [activetab, setActivetab] = useState<any>("kra");
  const [kraDetailsData, setKraDetailsData] = useState<any>([]);
  const [behaDetailsData, setBehaDetailsData] = useState<any>([]);
  const [comaspiDetailsData, setComaspiDetailsData] = useState<any>({
    employee_carrier_aspiration: "",
    employee_comments: "",
  });
  const routes = all_routes;

  const tabs = [
    { value: "kra", label: "KRA 80%" },
    { value: "Behavioural Competence", label: "Behavioural Competence" },
    { value: "Career Aspirations", label: "Career Aspirations" },
  ];

  const {
    data: getkradetails,
    loading: kradetailsLoading,
    error: kradetailsError,
  } = useApi("/api/kra-details", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    autoCall: !!finance_year,
    dependencies: [finance_year],
  });

  const {
    data: getbehaiviourdetails,
    loading: behaiviourdetailsLoading,
    error: behaiviourdetailsError,
  } = useApi("/api/get-behavioural-competence", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    autoCall: !!finance_year,
    dependencies: [finance_year],
  });

  const {
    data: getcomaspidetails,
    loading: comaspidetailsLoading,
    error: comaspidetailsError,
  } = useApi("/api/view-comments-aspiration", {
    method: "POST",
    payload: {
      financial_year: finance_year,
      category_id: localStorage.getItem("pms_category_id"),
    },
    autoCall: !!finance_year,
    dependencies: [finance_year],
  });

  useEffect(() => {
    if (getkradetails?.success) setKraDetailsData(getkradetails?.data);
  }, [getkradetails]);

  useEffect(() => {
    if (getbehaiviourdetails?.success) {
      setBehaDetailsData(getbehaiviourdetails?.data);
    }
  }, [getbehaiviourdetails]);

  useEffect(() => {
    if (getcomaspidetails?.success) {
      setComaspiDetailsData(getcomaspidetails?.data);
    }
  }, [getcomaspidetails]);

  const parseTarget = (target: any) => {
    try {
      if (!target) return [];
      return JSON.parse(target);
    } catch (e) {
      console.error("Error parsing target:", target);
      return [target]; // fallback
    }
  };

  console.log(comaspiDetailsData);

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">My Goals</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Work & Operations</li>
                  <li className="breadcrumb-item">PMS</li>
                  <li className="breadcrumb-item">
                    <Link to={all_routes.pmsGrid}>Goal Settings</Link>
                  </li>

                  <li className="breadcrumb-item active" aria-current="page">
                    My Goals
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex gap-2">
              <select
                value={finance_year}
                onChange={(e) => setFinance_year(e.target.value)}
                className="form-select"
              >
                {getFinancialYearListNew(finance_year).map((fy) => (
                  <option key={fy} value={fy}>
                    {fy}
                  </option>
                ))}
              </select>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>

          <section className="custom-card">
            <div className="custom-card-header d-flex justify-content-between align-items-center">
              <div className="d-flex gap-2">
                {tabs.map((item, index) => (
                  <button
                    className={`${
                      activetab === item.value
                        ? "btn btn-primary custom_button"
                        : "btn btn-primary tab-button"
                    }`}
                    onClick={() => {
                      setActivetab(item.value);
                    }}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
              <div>
                <button
                  className="btn btn-outline-dark"
                  data-bs-toggle="modal"
                  data-bs-target={
                    activetab === "Behavioural Competence"
                      ? "#behaviouralinfo"
                      : "#ratinginfo"
                  }
                >
                  <i className="fa fa-users"></i>
                </button>
              </div>
            </div>

            {activetab === "kra" ? (
              <>
                {kraDetailsData && kraDetailsData.length > 0 ? (
                  <div className="custom-table-wrapper">
                    <div className="custom-table-responsive">
                      <table className="custom-table">
                        <thead>
                          <tr style={{ color: "black" }}>
                            <th>SNo</th>
                            <th>Kra Category</th>
                            <th>Smart Goal</th>
                            <th>Target</th>
                            <th>Target Achievement Date</th>
                            <th>Attachment</th>
                            <th>Weightage(%)</th>
                            <th>Unit</th>
                          </tr>
                        </thead>
                        <tbody>
                          {kraDetailsData.map((item: any, idx: any) => {
                            return (
                              <tr key={item.id || idx}>
                                <td>{idx + 1}</td>
                                <td>{item.kra_category_name}</td>
                                <td>{item.smart_goals}</td>

                                <td>
                                  <ul className="mb-0">
                                    {parseTarget(item.target).map(
                                      (t: any, idx: any) => (
                                        <li key={idx}>
                                          {/* {idx + 1}.  */}
                                          {t}
                                        </li>
                                      ),
                                    )}
                                  </ul>
                                </td>

                                <td>{item.target_achievement_date}</td>

                                <td>
                                  {!item.attachment_url ||
                                  item.attachment_url.includes("null") ? (
                                    "N/A"
                                  ) : (
                                    <a
                                      href={item.attachment_url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      View
                                    </a>
                                  )}
                                </td>

                                <td>{item.weightage}%</td>
                                <td>{item.unit}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="p-2 d-flex justify-content-center">
                    <p
                      className="text-danger fw-bold"
                      style={{ fontSize: "15px" }}
                    >
                      No records found. Please ensure that your data is
                      correctly entered, or contact support for further
                      assistance.
                    </p>
                  </div>
                )}
              </>
            ) : activetab === "Behavioural Competence" ? (
              <>
                {behaDetailsData && behaDetailsData.length > 0 ? (
                  <div className="custom-table-wrapper">
                    <div className="custom-table-responsive">
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th>SNo</th>
                            <th>Behavioural Competency</th>
                            <th>Description</th>
                            <th>Weightage(%)</th>
                            {/* <th>Financial Year</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {behaDetailsData.map((item: any, idx: any) => {
                            return (
                              <tr key={item.id}>
                                <td>{idx + 1}</td>
                                <td>
                                  <p>{item.competency}</p>
                                </td>
                                <td>
                                  <ul className="mb-0">
                                    {item.description.map(
                                      (desc: string, idx: number) => (
                                        <li>
                                          {"L" + (idx + 1)}&nbsp;&nbsp;
                                          {desc}
                                        </li>
                                      ),
                                    )}
                                  </ul>
                                </td>
                                <td>{item?.weightage}%</td>
                                {/* <td>{item.financial_year || "N/A"}</td> */}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="p-2 d-flex justify-content-center">
                    <p
                      className="text-danger fw-bold"
                      style={{ fontSize: "15px" }}
                    >
                      No records found. Please ensure that your data is
                      correctly entered, or contact support for further
                      assistance.
                    </p>
                  </div>
                )}
              </>
            ) : (
              <>
                {kraDetailsData && kraDetailsData.length > 0 ? (
                  <>
                    <div className="p-2">
                      <div className="d-flex flex-column gap-4">
                        {/* Self Career Aspiration */}
                        <div className="d-flex flex-column">
                          <label className="form-label">
                            <strong>Self Career Aspiration</strong>
                          </label>
                          <textarea
                            name="employee_comments"
                            className="form-control"
                            rows={10}
                            value={
                              comaspiDetailsData?.employee_carrier_aspiration ||
                              ""
                            }
                            readOnly
                          />
                        </div>

                        {/* Manager Career Aspiration */}
                        {comaspiDetailsData?.manager_carrier_aspiration !==
                        null ? (
                          <div className="d-flex flex-column">
                            <label className="form-label">
                              <strong>Manager Career Aspiration</strong>
                            </label>
                            <textarea
                              name="manager_comments"
                              className="form-control"
                              rows={10}
                              value={
                                comaspiDetailsData?.manager_carrier_aspiration ||
                                ""
                              }
                              readOnly
                            />
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {comaspiDetailsData?.status === "E_SUBMIT" ||
                    comaspiDetailsData?.status === "M_APPROVED" ? (
                      <div className="p-2 d-flex gap-2">
                        <p className="text-danger fw-bold">
                          You have successfully submitted your Performance.
                          Please note that you will not be able to make any
                          further changes.
                        </p>
                      </div>
                    ) : null}
                  </>
                ) : (
                  <div className="p-2 d-flex justify-content-center">
                    <p
                      className="text-danger fw-bold"
                      style={{ fontSize: "15px" }}
                    >
                      No records found. Please ensure that your data is
                      correctly entered, or contact support for further
                      assistance.
                    </p>
                  </div>
                )}
              </>
            )}
          </section>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© 2025 WeConnect. All rights reserved.</p>
        </div>
      </div>
      {/* /Page Wrapper */}
      <div
        id="ratinginfo"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="standard-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="standard-modalLabel">
                Ratings & Calculation of your score
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="mb-4">
                <h5>
                  This year we are using a 5 point rating scale. The value
                  assigned to each rating is as below.
                </h5>
              </div>

              {/* Ratings Table */}
              <table className="table table-bordered">
                <thead className="table-light">
                  <tr>
                    <th>Rating</th>
                    <th>Description</th>
                    <th>Code</th>
                    <th>Scale</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>5</td>
                    <td>Outstanding</td>
                    <td>OS</td>
                    <td>4.01 - 5.00</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Very Good</td>
                    <td>VG</td>
                    <td>3.01 - 4.00</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Good</td>
                    <td>G</td>
                    <td>2.01 - 3.00</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Average</td>
                    <td>Avg</td>
                    <td>1.01 - 2.00</td>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>Poor</td>
                    <td>P</td>
                    <td>0.00 - 1.00</td>
                  </tr>
                </tbody>
              </table>
              <div className="mt-3">
                <p>
                  Your score is determined entirely by your score on your
                  KRA/KPI OR a composite where the weight of the KRA is 80%,
                  Behavioural is 20%
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="behaviouralinfo"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="behavioural-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="behavioural-modalLabel">
                Behavioural Competency – Rating Scale
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="modal-body">
              <div className="mb-4">
                <h5>
                  Behavioural competencies are assessed using a 4-level scale
                  ranging from Low (L1) to Exceeds Expectations (L4).
                </h5>
              </div>

              <table className="table table-bordered">
                <thead className="table-light">
                  <tr>
                    <th>Level</th>
                    <th>Rating</th>
                    <th>Description</th>
                    <th>Expectation</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>L1</td>
                    <td>Low</td>
                    <td>
                      Behaviour does not meet role requirements. Frequently
                      demonstrates gaps in expected competencies.
                    </td>
                    <td>Immediate improvement required</td>
                  </tr>

                  <tr>
                    <td>L2</td>
                    <td>Developing</td>
                    <td>
                      Shows basic understanding of behavioural expectations but
                      applies them inconsistently.
                    </td>
                    <td>Needs regular guidance</td>
                  </tr>

                  <tr>
                    <td>L3</td>
                    <td>Meets Expectations</td>
                    <td>
                      Consistently demonstrates expected behaviours aligned with
                      role requirements.
                    </td>
                    <td>Fully meets role standards</td>
                  </tr>

                  <tr>
                    <td>L4</td>
                    <td>Exceeds Expectations</td>
                    <td>
                      Frequently demonstrates strong behavioural competencies
                      and positively influences others.
                    </td>
                    <td>Above role expectations</td>
                  </tr>
                </tbody>
              </table>

              <div className="mt-3">
                <p>
                  Behavioural competency ratings focus on how consistently an
                  employee demonstrates expected behaviours such as
                  collaboration, accountability, communication, and leadership.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PerformanceReview;
